(function () {
  function bindCard(card) {
    if (card.dataset.laVideoReady === "true") return;
    const play = card.querySelector("[data-la-video-play]");
    const stage = card.querySelector("[data-la-video-stage]");
    const video = stage && stage.querySelector("video");
    const fsBtn = card.querySelector("[data-la-video-fs]");
    const muteBtn = card.querySelector("[data-la-video-mute]");
    const controls = card.querySelector(".la-videos__controls");
    if (!play || !stage || !video) return;

    card.dataset.laVideoReady = "true";
    video.muted = true;
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    const mutedIcon = muteBtn && muteBtn.querySelector("[data-icon-muted]");
    const unmutedIcon = muteBtn && muteBtn.querySelector("[data-icon-unmuted]");

    function paintMute() {
      if (!muteBtn) return;
      muteBtn.setAttribute("aria-label", video.muted ? "Unmute" : "Mute");
      if (mutedIcon) mutedIcon.hidden = !video.muted;
      if (unmutedIcon) unmutedIcon.hidden = video.muted;
    }

    function showControlsBriefly() {
      if (!controls) return;
      controls.classList.add("is-visible");
      clearTimeout(card.__laControlsTimer);
      card.__laControlsTimer = setTimeout(() => {
        controls.classList.remove("is-visible");
      }, 2200);
    }

    function tryPlay() {
      video.muted = true;
      const attempt = video.play();
      if (attempt && typeof attempt.then === "function") {
        attempt.catch(() => {
          const resume = () => {
            video.muted = true;
            video.play().catch(() => {});
          };
          if (video.readyState >= 2) {
            resume();
            return;
          }
          video.addEventListener("canplay", resume, { once: true });
          try {
            video.load();
          } catch (e) {
            /* ignore */
          }
        });
      }
    }

    function start() {
      play.hidden = true;
      play.setAttribute("hidden", "");
      stage.hidden = false;
      stage.removeAttribute("hidden");
      card.classList.add("is-playing");
      tryPlay();
      paintMute();
      showControlsBriefly();
    }

    play.addEventListener("click", start);

    function fullscreenElement() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        null
      );
    }

    function isFullscreen() {
      const active = fullscreenElement();
      return active === stage || active === video;
    }

    function syncFullscreenUi() {
      const active = isFullscreen();
      stage.classList.toggle("is-fullscreen", active);
      if (fsBtn) {
        fsBtn.setAttribute(
          "aria-label",
          active ? "Exit fullscreen" : "Enter fullscreen"
        );
      }
    }

    function exitFullscreen() {
      const exit =
        document.exitFullscreen ||
        document.webkitExitFullscreen ||
        document.msExitFullscreen;
      if (exit) {
        Promise.resolve(exit.call(document)).catch(() => {});
      }
    }

    function enterFullscreen() {
      const requestStage =
        stage.requestFullscreen ||
        stage.webkitRequestFullscreen ||
        stage.msRequestFullscreen;
      if (requestStage) {
        Promise.resolve(requestStage.call(stage)).catch(() => {
          if (typeof video.webkitEnterFullscreen === "function") {
            video.webkitEnterFullscreen();
          }
        });
        return;
      }
      if (typeof video.webkitEnterFullscreen === "function") {
        video.webkitEnterFullscreen();
        return;
      }
      if (video.requestFullscreen) {
        video.requestFullscreen().catch(() => {});
      }
    }

    document.addEventListener("fullscreenchange", syncFullscreenUi);
    document.addEventListener("webkitfullscreenchange", syncFullscreenUi);
    video.addEventListener("webkitbeginfullscreen", () => {
      stage.classList.add("is-fullscreen");
      if (fsBtn) fsBtn.setAttribute("aria-label", "Exit fullscreen");
    });
    video.addEventListener("webkitendfullscreen", () => {
      stage.classList.remove("is-fullscreen");
      if (fsBtn) fsBtn.setAttribute("aria-label", "Enter fullscreen");
    });

    if (fsBtn) {
      fsBtn.addEventListener("click", () => {
        if (isFullscreen()) {
          exitFullscreen();
        } else {
          enterFullscreen();
        }
        showControlsBriefly();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener("click", () => {
        video.muted = !video.muted;
        paintMute();
        showControlsBriefly();
      });
    }

    stage.addEventListener("click", (event) => {
      if (event.target.closest("button")) return;
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      showControlsBriefly();
    });

    video.addEventListener("ended", () => {
      video.currentTime = 0;
      video.pause();
      stage.hidden = true;
      stage.setAttribute("hidden", "");
      play.hidden = false;
      play.removeAttribute("hidden");
      card.classList.remove("is-playing");
    });

    paintMute();
  }

  function init(root) {
    (root || document).querySelectorAll("[data-la-video-card]").forEach(bindCard);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(document));
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
